import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faFacebook, faTwitter } from '@fortawesome/free-brands-svg-icons';
import { UtilsService } from '../../Services/utils.service';
import { NgIf } from '@angular/common';
import { faWallet } from '@fortawesome/free-solid-svg-icons';
import { ApiCallService } from '../../Services/api-call-service.service';
import { NotificationService } from '../../Services/notification.service';
import { ErrorhandlingService } from '../../Services/error-handling.service';
import { NotificationsComponent } from '../notifications/notifications.component';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-footer',
  imports: [FontAwesomeModule, NgIf, RouterModule, NotificationsComponent],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent implements OnInit {
  currentYear = new Date().getFullYear();
  isChatVisible: boolean = false;
  showNotifications = false;
  notifications: any[] = [];
  notificationCount = 0;

  constructor(
    private router: Router,
    private _utils: UtilsService,
    private apiCallService: ApiCallService,
    private notificationService: NotificationService,
    private errorHandlingService: ErrorhandlingService
  ) {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // Check for token and get chat count on each route change
        if (this.token) {
          this.getChatCount();
        }
      }
    });
    this._utils.showComponent$.subscribe((visible: boolean) => {
      this.isChatVisible = visible;
      // console.log('this.isChatVisible', this.isChatVisible);
      // if (!visible && this.token) {
      //   this.getChatCount();
      // }
    });
  }
  private destroy$ = new Subject<void>();
  facebook = faFacebook;
  twitter = faTwitter;
  @Input() chatUnreadCount: number = 0;
  // 'app' = default (post-login) footer; 'landing' = guest bottom nav on landing page
  @Input() mode: 'app' | 'landing' = 'app';
  @Output() authRequested = new EventEmitter<'login' | 'signup'>();
  get token(): string | null {
    // if (this.isBrowser) {
    const token = localStorage.getItem('token');
    return token;
    // }
    // return '';
  }
  activeFooterSection: string = 'dashboard';
  ngOnInit() {
    this._utils
      .getTriggerChatUnReadCountObservable()
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.getChatCount();
      });

    this.notificationService.notifications$
      .pipe(takeUntil(this.destroy$))
      .subscribe((notifs) => {
        this.notifications = notifs || [];
        this.notificationCount = this.notifications.length;
      });
  }
  unreadCounts: number = 0;
  Wallet = faWallet;
  async getChatCount() {
    try {
      await this.apiCallService
        .GetCallWithToken('NotificationMessages/GetUnReadChatMessages')
        .subscribe({
          next: (response) => {
            if (response.responseCode === 200) {
              this.unreadCounts = response.data[0].UnreadCount;
            }
          },
          error: (error) => {
            // this.apiCallService.handleError(error);
          },
        });
    } catch (error: any) {
      // this.apiCallService.handleError(error);
    }
  }
  RedirectDashboard() {
    if (localStorage.getItem('token')) {
      this.router.navigate(['/dashboard/home']);
    } else {
      this.router.navigate(['/login']);
    }
  }
  hideChatComponentAndRedirection() {
    this._utils.toggleComponentVisibility(false);
    // this._utils.showComponentSubject.next(false);
    // this._utils.showComponentSubject.closed = false;
    this._utils.triggerChatReadFunction();
  }
  RedirectSignup() {
    this.router.navigate(['/SignUp']);
  }

  // * Router navigation function
  changeRoute(path: string) {
    this._utils.toggleComponentVisibility(false);
    // this._utils.showComponent$.emit(false);
    this.router.navigate([path]);
    // this._utils.toggleComponentVisibility(false);
  }

  showChatComponent() {
    this._utils.toggleComponentVisibility(true);
  }
  isDashboardRoute(): boolean {
    // if (localStorage.getItem('token')) {
    return this.router.url.includes('dashboard');
    // }
  }
  isScreenWidthLessThan800(): boolean {
    return window.innerWidth < 800;
  }
  isTreasurePickRoute(): boolean {
    const current = this.router.url;
    return current === '/dashboard/TreasurePick' || current === '/dashboard/Avaitar' || current === '/dashboard/StackBuilder' || current === '/dashboard/Baccaret' || current === '/dashboard/Roulette' || current === '/dashboard/Mines' || current === '/dashboard/Plinko' || current === '/dashboard/Keno';
  }

  GoToDashboard() {
    this.activeFooterSection = 'dashboard';
    this.activeSection = 'dashboard';
    this.router.navigate(['/dashboard/home']);
  }

  GoToWallet() {
    this.activeFooterSection = 'wallet';
    this.activeSection = 'wallet';
    this.router.navigate(['/dashboard/wallet']);
  }

  GoToTermsAndConditions() {
    this.activeFooterSection = 'terms';
    this.activeSection = 'terms';
    this.router.navigate(['/Terms&Conditions']);
  }

  GoToPrivacyPolicy() {
    this.activeFooterSection = 'privacy';
    this.activeSection = 'privacy';
    this.router.navigate(['/PrivacyPolicy']);
  }

  activeSection: string = 'dashboard';

  scrollTo(id: string) {
    const element = document.getElementById(id);
    if (element) {
      const yOffset = -20;
      const y =
        element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  }

  toggleNotifications() {
    this.showNotifications = !this.showNotifications;
    if (this.showNotifications && this.notifications.length === 0) {
      this.notificationService.loadNotifications(true);
    }
  }

  openDepositModal() {
    this.errorHandlingService.showModalSubject.next(true);
  }

  onNotificationOpenChat() {
    this.showNotifications = false;
    this._utils.toggleComponentVisibility(true);
  }

  // Guest (landing mode) bottom-nav actions
  guestHome() {
    this.scrollTo('gameScrollSection');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  requestAuth(type: 'login' | 'signup') {
    this.authRequested.emit(type);
  }

}
